import React from "react";
import { _t } from "app/i18n/i18n";
import { isIntranetPath, isPublicPath } from "lib/routing";
import { ExternalLink } from "./DownloadExcelLink";

export const DownloadAnalystImages = (props) =>
  isIntranetPath() && !isPublicPath() ? (
    <ExternalLink
      url="/research/japi/analysts/download/images"
      label={_t("Download Analyst Images")}
      icon="fas fa-file-download text-success"
      className="float-right mx-sm-2"
      {...props}
    />
  ) : null;
